<div class="main-container">
	<div [innerHTML]="data.title | translate"></div>
	<div
		mat-dialog-actions
		[ngClass]="!!data.cancel && !!data.ok ? 'button-container-two-buttons' : 'button-container-one-button'"
	>
		<button
			*ngIf="data.cancel"
			mat-button
			mat-raised-button
			(click)="onCancelClick()"
		>
			{{ data.cancel | translate }}
		</button>
		<button
			*ngIf="data.ok"
			mat-button
			mat-raised-button
			[mat-dialog-close]="true"
			cdkFocusInitial
		>
			{{ data.ok | translate }}
		</button>
	</div>
</div>
